import { FC } from 'react'
import { MdOutlineSearch } from 'react-icons/md'

interface Props {
  placeholder?: string
  value?: string
  onChange?: (v: string) => void
}

const SearchInput: FC<Props> = ({ placeholder = 'Buscar...', value, onChange }) => (
  <div className='bg-[#f3f4fb] rounded-xl px-4 py-2.5 flex items-center gap-2'>
    <MdOutlineSearch className='text-gray-400 text-base flex-shrink-0' />
    <input
      type='text'
      className='bg-transparent outline-none text-sm flex-1'
      placeholder={placeholder}
      value={value ?? ''}
      onChange={(e) => onChange?.(e.target.value)}
    />
  </div>
)

export default SearchInput
